// @ts-nocheck
import React from 'react'
import {
	Button,
	Link,
} from '../../components/StyledComponents'
import { Page } from '../../components/ui/Page'
import { Stepper } from '../../components/features/Stepper'
import { Body } from '../../components/layout/Body'
import Store from '../../store/Store'
import { bookingStepLabels } from './bookingStepLabels'

// ============================================================================
// 6. Bestätigung
const BookingPage6 = () => {
	const bookingData = Store.bookingData
	const searchParams = new URLSearchParams(window.location.search)
	const hashSearch = window.location.hash.includes('?')
		? window.location.hash.substring(window.location.hash.indexOf('?'))
		: ''
	const hashParams = new URLSearchParams(hashSearch)
	const isNachzahlung =
		searchParams.get('nachzahlung') === '1' ||
		hashParams.get('nachzahlung') === '1'

	if (!bookingData) return null

	const orderId = Store.latestOrderId || bookingData?.id || 'd33c8ee0-a8b9-4a0a-a193-cc8bb2c95226'

	return (
		<div className="max-w-[1100px] mx-auto">
			<Page>
				<Body>
					{!isNachzahlung && (
						<Stepper numSteps={5} step={5} labels={bookingStepLabels} />
					)}

					<div className="w-full pt-20 pb-12">
						<div className="max-w-[980px] mx-auto">
							<h1 className="text-3xl leading-[1.15] font-semibold text-[#3A3A3A] tracking-[-0.02em]">
								Ihre Buchung wurde erfolgreich übermittelt.
							</h1>

							<div className="mt-16 text-base text-[#666]">
								<span className="font-medium text-[#666]">
									Auftragsnummer:
								</span>{' '}
								{orderId}
							</div>

							<div className="mt-20 max-w-[900px] text-base leading-[1.45] text-[#333]">
								<p>
									Ihr Auftrag wird nun geprüft. Sie erhalten eine
									Benachrichtigung, sobald der Flugtermin bestätigt
									ist.
								</p>

								<p className="mt-2">
									Sie können den aktuellen Status jederzeit in{' '}
									<a className="text-[#0063A3] underline"
										data-pw="link-faq"
										href="/#/orders">
										Meine Aufträge
									</a>{' '}einsehen.
								</p>
							</div>

							<div className="mt-24 flex justify-end">
								<div className='w-[200px]'>
									<Button
										data-pw="button-next"
										primary
										onClick={() => Store.navigate('dashboard')}
									>
										Abschließen
									</Button>
								</div>
							</div>
						</div>
					</div>
				</Body>
			</Page>
		</div>
	)
}

export default BookingPage6
